<template>
  <div class="side-modal p-30" ref="sideModal">
    <div class="close-side-modal" @click="close"></div>
    <component v-bind:is="dashSideModalComponent" :data="dashSideModalContent"></component>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { Loading } from 'element-ui';
import SingleTransactionModal from '@/components/dashboard/SingleTransactionModal.vue'

export default {
  name: 'side-modal',
  components: {
    SingleTransactionModal
  },
  computed: {
    ...mapFields({
      sideModalOpen: 'ui.sideModalOpen',
      dashSideModalComponent: 'dashSideModalComponent',
      dashSideModalContent: 'dashSideModalContent'
    })
  },
  watch: {
    dashSideModalContent(val) {
      this.loader()
    }
  },
  methods: {
    close() {
      this.$store.commit('showHideSideModal', {
        show: false,
        component: '',
        payload: null
      })
    },
    loader() {
      const loading = this.$loading({
        lock: true,
        target: this.$refs.sideModal,
        background: '#ffffff'
      });

      setTimeout(() => {
        loading.close();
      }, 1500);
    }
  },
  mounted() {
    this.loader()
  }
}
</script>